import { Box, LinkButton, Typography } from '@pinwheel/origami';
import React, { useMemo } from 'react';
import useLinkNavigate from './hooks/useLinkNavigate';
import { useOpts } from './context';
import { useGetLocalizedString } from './hooks/useGetLocalizedString';
export var TermsOfServiceTextVariant;
(function (TermsOfServiceTextVariant) {
    TermsOfServiceTextVariant["CONTINUE_BUTTON"] = "continue_button";
    TermsOfServiceTextVariant["GET_STARTED_BUTTON"] = "get_started_button";
    TermsOfServiceTextVariant["PROCEEDING"] = "proceeding";
})(TermsOfServiceTextVariant || (TermsOfServiceTextVariant = {}));
var TermsOfService = function (_a) {
    var _b = _a.textVariant, textVariant = _b === void 0 ? TermsOfServiceTextVariant.CONTINUE_BUTTON : _b, textColor = _a.textColor;
    var getLocalizedString = useGetLocalizedString();
    var fireTrackEvent = useOpts().fireTrackEvent;
    var navigate = useLinkNavigate();
    var onTermsOfService = function () {
        fireTrackEvent('Link Intro TermsOfService');
        navigate('/terms');
    };
    var onPrivacyPolicy = function () {
        fireTrackEvent('Link Intro PrivacyPolicy');
        navigate('/privacy-policy');
    };
    var termsText1 = useMemo(function () {
        var _a;
        var textMap = (_a = {},
            _a[TermsOfServiceTextVariant.CONTINUE_BUTTON] = getLocalizedString('TERMS_1'),
            _a[TermsOfServiceTextVariant.GET_STARTED_BUTTON] = getLocalizedString('TERMS_1_GET_STARTED'),
            _a[TermsOfServiceTextVariant.PROCEEDING] = getLocalizedString('TERMS_1_PROCEEDING'),
            _a);
        return textMap[textVariant];
    }, [textVariant, getLocalizedString]);
    return (React.createElement(Box, null,
        React.createElement(Typography, { sx: { textAlign: 'center' }, "data-testid": "terms", variant: "postscript", color: textColor || 'light' },
            termsText1,
            ' ',
            React.createElement(LinkButton, { "data-testid": "terms-termsOfService", onClick: onTermsOfService }, getLocalizedString('TERMS_2')),
            ' ',
            getLocalizedString('TERMS_3'),
            ' ',
            React.createElement(LinkButton, { "data-testid": "terms-privacyPolicy", onClick: onPrivacyPolicy }, getLocalizedString('TERMS_4')),
            getLocalizedString('TERMS_5'),
            ".")));
};
export default TermsOfService;
